import { createAction } from 'typesafe-actions';

export const UPDATE_PROGRAMBOOKING = 'programBooking/UPDATE_PROGRAMBOOKING';

export const getProgramBookingAsync = createAction(UPDATE_PROGRAMBOOKING, (parameters) => parameters)()


